import { render } from "./CommonProblem.vue?vue&type=template&id=5941a732&scoped=true"
import script from "./CommonProblem.vue?vue&type=script&lang=js"
export * from "./CommonProblem.vue?vue&type=script&lang=js"

import "./CommonProblem.vue?vue&type=style&index=0&id=5941a732&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5941a732"]])

export default __exports__